module.exports = __webpack_public_path__ + "img/stores-frame1.eeedbcc6.png";